import { render } from "./cmpltSalComp.vue?vue&type=template&id=6269d54f"
import script from "./cmpltSalComp.vue?vue&type=script&lang=js"
export * from "./cmpltSalComp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__